export { WorkspacePropertyIcon } from './icons/workspace-property-icon';
export { WorkspacePropertyName } from './name';
export * from './table';
